
import type { PropType } from 'vue'

import type { ClusterFeatureEntity, DispatcherWorkplaceDelivery, DispatcherWorkplaceRecordWaitListStatus, DispatcherWorkplaceTake } from '@/modules/DispatcherWorkplaceModule/types'
import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'

import { defineComponent, computed } from 'vue'

import DwStatus from '@/modules/DispatcherWorkplaceModule/components/DwStatus/index.vue'
import DwWaitListStatus from '@/modules/DispatcherWorkplaceModule/components/DwWaitListStatus/index.vue'
import DwButton from '@/modules/DispatcherWorkplaceModule/ui/DwButton/index.vue'
import DwBadge from '@/modules/DispatcherWorkplaceModule/ui/DwBadge/index.vue'

import declOfNum from '@/common/helpers/declOfNum'

import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        DwStatus,
        DwWaitListStatus,
        DwButton,
        DwBadge
    },
    props: {
        feature: {
            type: Object as PropType<ClusterFeature<ClusterFeatureEntity>>,
            required: true
        },
    },
    emits: [
        'close',
        'change-date',
        'add-to-wait-list',
        'assign',
        'self-delivery'
    ],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const onClose = () => {
            emit('close')
        }

        const onChangeDate = () => {
            emit('change-date', { ...props.feature })
        }

        const onAddToWaitList = () => {
            emit('add-to-wait-list', { ...props.feature })
        }

        const onAssign = () => {
            emit('assign', { ...props.feature })
        }

        const onSelfDelivery = () => {
            emit('self-delivery', { ...props.feature })
        }

        const copyNumber = () => {
            if (featureEntity.value) {
                let text = 'Номер заказа скопирован'
                let buffer = null as string | null

                if (featureEntity.value.type === 1) {
                    buffer = (featureEntity.value as DispatcherWorkplaceTake).orderNumber
                }

                if (featureEntity.value.type === 2) {
                    buffer = (featureEntity.value as DispatcherWorkplaceDelivery).invoiceNumber
                    text = 'Номер накладной скопирован'
                }

                navigator.clipboard.writeText(buffer as string)
                notifications.notify({ title: text, type: 'success' })
            }
        }

        const featureEntity = computed(() => {
            if (props.feature.entity) {
                return props.feature.entity
            }

            return null
        })

        const isTake = computed(() => {
            if (props.feature.entity) {
                return props.feature.entity.type === 1 && !(props.feature.entity as DispatcherWorkplaceTake).notAssigned
            }
            
            return false
        })

        const isUnassignedTake = computed(() => {
            if (props.feature.entity) {
                return props.feature.entity.type === 1 && (props.feature.entity as DispatcherWorkplaceTake).notAssigned
            }

            return false
        })

        const isDelivery = computed(() => {
            if (props.feature.entity) {
                return props.feature.entity.type === 2 && !(props.feature.entity as DispatcherWorkplaceDelivery).notDelivered
            }

            return false
        })

        const isUndeliveredDelivery = computed(() => {
            if (props.feature.entity) {
                return props.feature.entity.type === 2 && (props.feature.entity as DispatcherWorkplaceDelivery).notDelivered
            }

            return false
        })

        return {
            declOfNum,
            onClose,
            onChangeDate,
            onAddToWaitList,
            onAssign,
            onSelfDelivery,
            copyNumber,
            featureEntity,
            isTake,
            isUnassignedTake,
            isDelivery,
            isUndeliveredDelivery
        }
    }
})
